import {useTheme} from '@mui/material';

import {HomeEnum, ServicesEnum} from 'presentation/constants';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {useLocation, useNavigate} from 'react-router-dom';

export const useExamResultsWrapper = () => {
	const {isMobile} = useMediaQueries();
	const theme = useTheme();
	const {state: routeState} = useLocation();
	const navigate = useNavigate();

	const handleBack = () => {
		if (routeState && routeState.includes(ServicesEnum.SERVICES)) {
			navigate(routeState);
			return;
		}
		navigate(HomeEnum.HOME_PAGE);
	};

	return {
		isMobile,
		theme,
		handleBack,
	};
};
